export default __webpack_public_path__ + "static/B0276-cb9bbfab110a9914b085bd1593cabe16.png";